<template>
  <div>
    <div id="login" v-if="showPage">
      <div @click="toDetail(item)" class="contentList" :key="index" v-for="(item, index) in favarticle">
        <div style="display: inline-block;width: 20%;vertical-align: center;margin-right: 2%;">
          <img style="width: 100%;" :src="baseUrl + '/api/Article/file/' + item.fileID">
        </div>
        <div class="NoWrap" style="display: inline-block;width: 70%;vertical-align: middle;">{{item.title}}</div>
      </div>
      <div class="no-favorites" v-if="favarticle.length === 0">
        <img src="../../assets/no_favorites_bg.png" alt="">
      </div>
    </div>
    <!--<div v-if="showGuide" class="guideTofollow"></div>-->
    <div v-if="showGuide" class="guideTofollowImg">
      <img src="../../assets/guide_background_prod.png" />
    </div>
    <agreeBookDialog :ABDialogShow="ABDialogShow" :openId="openId" @ABDialogShowFn="ABDialogShowFn"></agreeBookDialog>
  </div>
</template>

<script>
import agreeBookDialog from "./agreeBookDialog";
import merge from 'webpack-merge';
import axios from 'axios';
let intervalTime
export default {
  name: 'login',
  components: {
    agreeBookDialog
  },
  data () {
    return {
      showPage: false,
      baseUrl: process.env.config.baseUrl,
      postData: {
        docName: '',
        department: '',
        Province: '',
        instName: '',
        City: ''
      },
      loginName: '',
      password: '',
      openId: '',
      doctorId: '',
      departList: [],
      provList: [],
      liked: false,
      ABDialogShow:false,
      hospitalList: [],
      favarticle: [],
      cityList: [],
      redirectUrl: this.$route.query.redirectUrl,
      appid: localStorage.appId,
      openid: localStorage.openId,
      contentData: {},
      likedData: {},
      returnurl: decodeURIComponent(this.$route.query.returnurl || ''),
      time: 0,
      startId: 0,
      showGuide: false,
      jumptovctag: this.$route.query.jumptovctag || '',
      NewerTag: this.$route.query.NewerTag || '',
      takedacode: this.$route.query.takedacode || ''
    }
  },
  created () {
    clearInterval(intervalTime)
    document.title = '我的收藏'

//判断会传参数中是否有 jumptovctag ，如有则证明已经跳过了，如无，则无论如何都跳转
// if(!this.jumptovctag){
//   //进入收藏登录前埋点
//   this.actionBurialPoint(2)
//   let url = process.env.config.baseUrl + '/api/wechat/oauth2/authorize?redirect_uri=' + encodeURIComponent('https://' + window.location.host + '/favConList?id=' + 0 + '&returnurl=' + (this.returnurl || ''))
//    window.location.href = url
//  }


     //如果参数中含有新用户标记，则清理缓存 (当前未考虑员工，仅考虑了医生)
     if(this.NewerTag=='Hcp'){
      window.sessionStorage.removeItem("LsData");
                // 注册成功删除暂存的用户信息
      window.localStorage.removeItem("registerUserInfo");
      window.localStorage.removeItem("registerNonHCPInfo");
                // 删除员工标识
      window.localStorage.removeItem("isEmployee");
    }
    else if(this.NewerTag=='Emp')
    {
      window.localStorage.setItem('isEmployee', true);

    }
    else if(this.NewerTag=='NoHcp')
    {
      window.localStorage.removeItem("registerNonHCPInfo");
      window.localStorage.removeItem("registerUserInfo");
    }
    // let that = this
    if (!localStorage.TaToken && !this.takedacode) {
      // process.env.config.baseUrl
      // window.location.host
      //进入收藏登录前埋点
      this.actionBurialPoint(2)
      setTimeout(()=>{
        let url = process.env.config.baseUrl + '/api/wechat/oauth2/authorize?redirect_uri=' + encodeURIComponent('https://' + window.location.host + '/favConList?id=' + 0 + '&returnurl=' + (this.returnurl || ''))
        window.location.href = url
      },2000)
      
      // this.$axiox.get(url).then(msg => {
      //   console.log(msg)
      // })
      return
    } else {
      if (this.takedacode && !localStorage.TaToken) {
        window.sessionStorage.setItem('isOne','')
         
        this.$axiox.get('/Login/GetTokenByCode?code=' + this.takedacode).then(msg => {
          // 获取当前 URL
          const url = new URL(window.location.href);
          // 获取 URLSearchParams 对象
          const params = url.searchParams;
          // 删除指定的查询参数
          params.delete('takedacode');
          // 更新浏览器地址
          window.history.replaceState({}, '', url);
          
          localStorage.TaToken = msg.token
          localStorage.appId = msg.appId
          localStorage.openId = msg.openId
          this.openId = msg.openId
          let isEmployee = window.localStorage.getItem('isEmployee')
          let allAxiox = ''
          //进入收藏登录后埋点
          this.actionBurialPoint(3)

          setTimeout(() => {
            this.getSignDetail();
            if(!window.sessionStorage.getItem('isOne')){
              this.actionBurialPoint(5)
              window.sessionStorage.setItem('isOne',true)
            }
            }, 1000);

          if (isEmployee) {
            let data = {
              openId: this.openId,
              returnurl: encodeURIComponent(this.returnurl)
            }
            allAxiox = this.$axiox.postNoRes(process.env.config.baseUrl + '/api/wechat/getEmployee', data)
          } else {
            let data = {
              openid: this.openId,
              returnurl: encodeURIComponent(this.returnurl)
            }
            allAxiox = this.$axiox.postNoRes(process.env.config.baseUrl + '/api/wechat/getDoctor', data)
          }

          if(this.NewerTag=='NoHcp'){

this.$commonJs.mobileDoubleComfirm({
buttonType: "0",
type: "warning",
title: "提示",
content:
  "该平台仅供医疗卫生专业人士（HCP）使用，您已注册非HCP，暂无权限！",
successFun: () => {
},
errorFun: (err) => {},
});

}


          allAxiox.then(msg => {
            console.log(msg, 'getDoctor')
            if (msg.isSuccess) {
              if (msg.data.status === 2) {
                //window.location.href = 'https://' + window.location.host + '/register?returnurl=' + encodeURIComponent((window.location.href || ''))
              } else if (msg.data.status === 3) {
                //window.location.href = 'https://' + window.location.host + '/register?returnurl=' + encodeURIComponent((window.location.href || ''))
              } else {
                if (msg.data.isFollowed) {
                  this.showPage = true
                  this.getFavList()
                } else {
                  // this.$commonJs.closeWindow()
                  this.showGuide = true
                }
              }
            }
          })
        })
      } else {
        
        this.openId = localStorage.openId
        let isEmployee = window.localStorage.getItem('isEmployee')
        let allAxiox = ''

        setTimeout(() => {
            this.getSignDetail();
            if(!window.sessionStorage.getItem('isOne')){
              this.actionBurialPoint(5)
              window.sessionStorage.setItem('isOne',true)
            }
            }, 1000);
            
        if (isEmployee) {
          let data = {
            openId: this.openId,
            returnurl: encodeURIComponent(this.returnurl)
          }
          allAxiox = this.$axiox.postNoRes(process.env.config.baseUrl + '/api/wechat/getEmployee', data)
        } else {
          let data = {
            openid: this.openId,
            returnurl: encodeURIComponent(this.returnurl)
          }
          allAxiox = this.$axiox.postNoRes(process.env.config.baseUrl + '/api/wechat/getDoctor', data)
        }

        if(this.NewerTag=='NoHcp'){

this.$commonJs.mobileDoubleComfirm({
buttonType: "0",
type: "warning",
title: "提示",
content:
  "该平台仅供医疗卫生专业人士（HCP）使用，您已注册非HCP，暂无权限！",
successFun: () => {
},
errorFun: (err) => {},
});

}

        allAxiox.then(msg => {
          console.log(msg, 'getDoctor')
          if (msg.isSuccess) {

            
            if (msg.data.status === 2) {
              //window.location.href = 'https://' + window.location.host + '/register?returnurl=' + encodeURIComponent((window.location.href || ''))
            } else if (msg.data.status === 3) {
              //window.location.href = 'https://' + window.location.host + '/register?returnurl=' + encodeURIComponent((window.location.href || ''))
            } else {
              if (msg.data.isFollowed) {
                this.showPage = true
                this.getFavList()
                
              } else {
                // this.$commonJs.closeWindow()
                this.showGuide = true
              }
            }
          }
        })
      }

      
    }
    // if (window.location.href.indexOf('openid') < 0) {
    //   // process.env.config.baseUrl
    //   // window.location.host
    //   let url = process.env.config.baseUrl + '/api/wechat/oauth2/authorize?redirect_uri=' + encodeURIComponent('https://' + window.location.host + '/favConList?id=' + 0 + '&returnurl=' + (this.returnurl || ''))
    //   // this.$axiox.get(url).then(msg => {
    //   //   console.log(msg)
    //   // })
    //   window.location.href = url
    // } else {
    //   this.openId = this.$route.query.openid
    //   let isEmployee = window.localStorage.getItem('isEmployee')
    //   let requestUrl = ''
    //   if (isEmployee) {
    //     requestUrl = '/api/wechat/getEmployee/'
    //   } else {
    //     requestUrl = '/api/wechat/getDoctor/'
    //   }
    //   this.$axiox.getNoRes(process.env.config.baseUrl + requestUrl + this.openId + '?returnurl=' + encodeURIComponent(this.returnurl)).then(msg => {
    //     console.log(msg, 'getDoctor')
    //     if (msg.isSuccess) {
    //       if (msg.data.status === 2) {
    //         window.location.href = 'https://' + window.location.host + '/register?returnurl=' + encodeURIComponent((window.location.href || ''))
    //       } else if (msg.data.status === 3) {
    //         window.location.href = 'https://' + window.location.host + '/register?returnurl=' + encodeURIComponent((window.location.href || ''))
    //       } else {
    //         if (msg.data.isFollowed) {
    //           this.showPage = true
    //           this.getFavList()
    //         } else {
    //           // this.$commonJs.closeWindow()
    //           this.showGuide = true
    //         }
    //       }
    //     }
    //   })
    // }

    


  },
  beforeDestroy(){
    clearInterval(intervalTime)
  },
  beforeRouteLeave(to, from, next) {
    clearInterval(intervalTime)
    next();
  },
  mounted () {
    intervalTime = setInterval(()=>{
      this.endBurialPoint()
    },2000)
  },
  methods: {
    actionBurialPoint(actionType){
      let data = {
            openid:this.openId || window.localStorage.getItem('openId'),
            actionType,
            url:window.location.href
          }
          this.$axiox.post('/api/Logs/logstart', data).then( p => {
            console.log('行为埋点')
            
            if(p){
              window.sessionStorage.setItem('transactionId',p)
            }
          } )
    },
    endBurialPoint(){
      const transactionId = window.sessionStorage.getItem('transactionId')
      axios.get(`/api/Logs/logend/${transactionId}`).then( p => {
      console.log('收藏刷新埋点')
    } )
    },
    getSignDetail() {
      let data = {
        openid: this.openId,
        docCode: "",
      };
      this.$axiox.postNoRes("/api/hcp/getHcpSignDetail", data).then((p) => {
        if (p.data == "True") {
         if(this.showGuide!=true){
          //name: "agreeBook",
          this.ABDialogShow = true
          }
        } else if (p.data == "False") {
        } //无需重新签署
        else {
        } //返回值错误
      });
    },
    ABDialogShowFn() {
      this.ABDialogShow =false;
    },
    toDetail (item) {
      localStorage.setItem('firstVisitUrl', location.href.split('#')[0].split('?')[0]);
      this.$router.push({
        name: 'mobileContent',
        query: {
          id: item.articleID,
          redirectUrl: '',
          takedacode: '',
          source: 'WY',
          openid: this.openid,
          appid: this.appid,
          jumptovctag: this.$route.query.jumptovctag || '',
          NewerTag: this.$route.query.NewerTag || ''
        }
      })
    },
    getFavList () {
      this.$axiox.get('/api/ArticlDoctor/favarticle?openid=' + this.openId + '&PageIndex=1&PageSize=9999').then(p => {
        this.favarticle = p
      })
    }
  }
}
</script>

<style scoped>
  .sl_color {
    color: #408DEB;
  }
  #login{
    justify-content: center;
    align-items: center;
    height: 100vh;
    overflow: auto;
    padding: 0 5%;
    background-color: #fff;
  }
  .title{
    margin-top: 5px;
    font-size: 14px;
  }
  .contentList{
    padding: 20px;
    border-bottom: 1px solid #eee;
  }
  .no-favorites {
    width: 100%;
    height: 100vh;
    position: relative;
  }
  .no-favorites img {
    display: block;
    width: 50%;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
</style>



// WEBPACK FOOTER //
// src/components/login/favConList.vue